import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link, Redirect, Route, Router as BrowserRouter, Switch } from 'react-router-dom';
import * as RX from 'reactxp';

import { Provider } from 'react-redux';
import EmergencyBanner from '../../components/emergency_banner';
import Popup from '../../components/popup';
import Spinner from '../../components/spinner';

import RouterWrapper from './web_wrapper';

import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

interface RouterProps {
  store: any;
  routes: { notWrappedRoutes: any[], wrappedRoutes: any[] };
  menuItems: any;
};

const ScrollToTop = withRouter(
  class ScrollToTopWithoutRouter extends React.Component<RouteComponentProps> {
    public componentDidUpdate(prevProps: Readonly<RouteComponentProps<any>>) {
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0);
      }
    }

    public render() {
      return null;
    }
  }
);

class Router extends React.Component<RouterProps> {
  private height;
  private width;

  constructor(props: RouterProps) {
    super(props);
  }

  public render() {
    const { store, routes, menuItems } = this.props;

    window.addEventListener('resize', () => {
      store.dispatch({
        height: window.innerHeight,
        multiplier: Math.ceil(window.innerWidth / window.screen.availWidth),
        type: 'WINDOW_RESIZE',
        width: window.innerWidth,
      });
      this.height = window.innerHeight;
      this.width = window.innerWidth;
    });

    return (
      <Provider {...{ store }}>
        <BrowserRouter history={history}>
          <RX.View
            onLayout={() => store.dispatch({ type: 'WINDOW_RESIZE' })}
            style={{ height: this.height, width: this.width }}
          >
            <ScrollToTop />
            <RouterWrapper { ...{ menuItems, routes }} /> {/*tslint:disable-line*/}
            <Popup />
            <EmergencyBanner />
            <Spinner />
          </RX.View>
        </BrowserRouter>
      </Provider>
    );

  }
}

export { Link, Redirect };

export default Router;



// WEBPACK FOOTER //
// ./src/modules/routing/index.web.tsx